import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../../../components/AnimatedSection/AnimatedSection';
import './AboutMissionSection.scss';

const AboutMissionSection = () => {
    const { t } = useTranslation();
    const prefersReducedMotion = useReducedMotion();

    const fadeUp = (delay, duration = 1.0) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 20 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration, delay, ease: EASE_OUT_EXPO },
              };

    return (
        <section className="about-mission">
            <div className="about-mission__outer">
                <div className="about-mission__inner">

                    <div className="about-mission__row">
                        <motion.div className="about-mission__card about-mission__card--title" {...fadeUp(0, 1.1)}>
                            <h2 className="about-mission__heading">{t('mission')}</h2>
                        </motion.div>
                        <motion.div className="about-mission__card about-mission__card--text" {...fadeUp(0.15)}>
                            <p className="about-mission__paragraph">
                                {t('mission_text')}
                            </p>
                        </motion.div>
                    </div>

                    <div className="about-mission__row">
                        <motion.div className="about-mission__card about-mission__card--title" {...fadeUp(0, 1.1)}>
                            <h2 className="about-mission__heading">{t('vision')}</h2>
                        </motion.div>
                        <motion.div className="about-mission__card about-mission__card--text" {...fadeUp(0.15)}>
                            <p className="about-mission__paragraph">
                                {t('vision_text')}
                            </p>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutMissionSection;